import { Link } from 'react-router-dom'

const LAST_UPDATED = 'May 2026'
const CONTACT = 'hello@themarginsjournal.com'

export default function TermsPage() {
  return (
    <div style={s.page}>
      <div style={s.content}>
        <p style={s.eyebrow}>Legal</p>
        <h1 style={s.title}>Terms of Service</h1>
        <p style={s.meta}>Last updated: {LAST_UPDATED}</p>

        <Section title="The one rule">
          One rule on The Margins: mean it. If you published it because you actually think it, it belongs here. If you published it to sound smart, stir outrage, or get attention, it doesn't. We reserve the right to remove content that violates this principle as judged by our editorial team.
        </Section>

        <Section title="Who can use The Margins">
          You must be at least 13 years old to create an account. By creating an account, you confirm you meet this requirement. If you are under 18, you should have parental permission to use online platforms.
        </Section>

        <Section title="Your content is yours">
          Everything you write on The Margins belongs to you. You grant us a non-exclusive, royalty-free licence to display, store, and distribute your content on the platform. This does not give us ownership. You can export your entire body of work at any time from Dashboard → Export and delete your account whenever you choose.
        </Section>

        <Section title="What you agree not to do">
          You agree not to publish content that is defamatory, harasses specific individuals, incites violence, or is illegal under Indian law or the laws of your jurisdiction. You agree not to impersonate others, spam the platform, or use automated tools to generate content. Violations may result in content removal or account suspension at our discretion.
        </Section>

        <Section title="Anonymous publishing">
          The Cold Open feature allows anonymous publishing. Anonymous posts are still subject to these terms. If an anonymous post violates these terms, it will be removed regardless of whether it has been claimed.
        </Section>

        <Section title="The rank system">
          Column Inches (CI) and Press ranks are earned through platform activity. We reserve the right to adjust the CI system, recalibrate ranks, or award/revoke editorial appointments at any time. The Voice rank (rank 12) is an editorial appointment and is not earned automatically under any circumstances.
        </Section>

        <Section title="Account suspension">
          We reserve the right to suspend or terminate accounts that repeatedly violate these terms, engage in harassment, or damage the platform community. We will notify you before taking action where possible. You can appeal decisions by emailing {CONTACT}.
        </Section>

        <Section title="Platform availability">
          We aim to keep The Margins running but cannot guarantee uptime. We are not liable for data loss, though we take reasonable steps to back up data. The platform is provided as-is.
        </Section>

        <Section title="Changes">
          We may update these terms. If changes are material, signed-in users will be notified via the platform notification system.
        </Section>

        <Section title="Contact">
          Questions about these terms: <a href={`mailto:${CONTACT}`} style={s.link}>{CONTACT}</a>
        </Section>

        <p style={{ ...s.meta, marginTop: '3rem' }}>
          <Link to="/privacy" style={s.link}>Privacy Policy</Link>
          {' · '}
          <Link to="/support" style={s.link}>Support</Link>
        </p>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '2rem' }}>
      <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '1.05rem', fontWeight: 700, marginBottom: '0.6rem', color: 'var(--ink)' }}>{title}</h2>
      <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.92rem', color: 'var(--muted)', lineHeight: 1.8 }}>{children}</p>
    </div>
  )
}

const s = {
  page: { paddingTop: '4.5rem', minHeight: '100vh' },
  content: { maxWidth: 680, margin: '0 auto', padding: '4rem 2rem 6rem' },
  eyebrow: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '0.75rem' },
  title: { fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(2rem, 5vw, 2.8rem)', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '0.5rem' },
  meta: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', color: 'var(--muted)', marginBottom: '3rem' },
  link: { color: 'var(--accent)', textDecoration: 'underline' },
}
